import React, { useMemo } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { useText } from '../hooks/useText';


const Text = ({ children, values = {} }) => {
  const message = useText(children);

  return useMemo(() => (
    <span qa-id={children}>
      <FormattedHTMLMessage
        id={children}
        defaultMessage={message}
        values={values}
      />
    </span>
  ), [message, values, children]);
};

export default Text;
